<template>
   <v-container class="my-auto d-flex flex-column">
          <v-card class="mx-auto pa-1 rounded-xl mx-4 " height="350" width="390">
            <v-card-title class="mt-4 justify-center">
              <h2 class="text-h5 font-weight-bold text-center">
                Change your password
              </h2>
            </v-card-title>
            <v-card-text class="mt-4">
              <v-form>
                <v-progress-linear v-if="loading" indeterminate/>
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :error-messages="passwordErrors"
                    :type="showPassword ? 'text' : 'password'"
                    label="New Password"
                    @blur="$v.password.$touch()"
                    @input="$v.password.$touch()"
                    @click:append="showPassword = !showPassword"
                />
                <v-text-field
                    v-model="confirmPassword"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :error-messages="confirmPasswordErrors"
                    :type="showConfrimPassword ? 'text' : 'password'"
                    label="Confirm password"
                    @blur="$v.confirmPassword.$touch()"
                    @input="$v.confirmPassword.$touch()"
                    @click:append="showConfrimPassword = !showConfrimPassword"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  :disabled="$v.$invalid || loading"
                  class="btn-text px-2 py-2 mx-auto"
                  color="primary"
                  type="submit"
                  @click="changePassowrd"
              >
                Change Password
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
</template>

<script>
import {minLength, required, sameAs} from "vuelidate/lib/validators";
import Logo from "@/assets/guiomentorLogo.png";

export default {
  metaInfo() {
    return {
      title: 'Guiomentor - Reset Password',
      url: window.location.href,
      meta: [
        {name: 'title', content: 'Guiomentor - Reset Password'},
        {
          name: 'description',
          content: this.description
        },
        //Facebook
        {name: 'og:type', content: 'Website'},
        {name: 'og:title', content: "Guiomentor - Reset Password"},
        {name: 'og:description', content: this.description},
        {name: 'og:image', content: this.Logo},

        // Twitter
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:url', content: window.location.href},
        {name: 'twitter:title', content: "Guiomentor - Reset Password"},
        {name: 'twitter:description', content: this.description},
        {name: 'twitter:image', content: this.Logo},
      ]
    }
  },
  data() {
    return {
      Logo,
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfrimPassword: false,
      loading: false,
      description: "Guiomentor is a platform directed to a niche of 10 to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest "

    };
  },
  mounted() {
    if (!this.$route.query.token) {
      this.$router.push({name: 'signin'})
    }
  },
  methods: {
    async changePassowrd() {
      try {
        this.loading = true;
        let token = this.$route.query.token;
        let body = {token, password: this.password}
        await this.axios.post('/password_reset/confirm/', body);
        this.$snackbar.showMessage({
          content: "password successfully changed",
          color: "success",
        });
        this.loading = false;
        await this.$router.push({name: 'sign-in'})
      } catch (error) {

        this.$snackbar.showMessage({
          content: error.response.status == 404 ? "invalid token" : (error.response.data.password).join(",") || this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
        this.loading = false;
      }
    },
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
      errors.push(this.$t("auth.forms.errors.passwordRequired"));
      !this.$v.password.min &&
      errors.push(this.$t("auth.forms.errors.passwordLength"));
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      !this.$v.confirmPassword.required &&
      errors.push(this.$t("auth.forms.errors.passwordRequired"));
      !this.$v.confirmPassword.min &&
      errors.push(this.$t("auth.forms.errors.passwordLength"));
      !this.$v.confirmPassword.sameAsPassword &&
      errors.push(this.$t("passwords dont match"));
      return errors;
    },
  },
  validations: {
    password: {required, min: minLength(8)},
    confirmPassword: {
      required,
      min: minLength(8),
      sameAsPassword: sameAs("password"),
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.full-container {
  height: 100%;

  .row {
    margin: 0;
  }
}

.left {
  background: #0033AA;
  height: 100vh;
  margin-top: 0;
  margin-bottom: 0;

  .logo {
    width: 120px;
    height: 120px;
  }

  .mini-column {
    elevation: higher;
    background: linear-gradient(to right, #b7edeb, #54ded2);
    min-height: 65%;
    max-width: 90%;
    border-radius: 5px;
  }
}

.right {
  background: #f5f6f8;
  height: 100vh;
}

</style>
